import modalStyle from "../modal.module.scss";

import React, { useEffect, useState } from 'react';
import { ReactComponent as CloseIcon } from "assets/images/icons/icn_close.svg";
import qrCodeImg from "assets/images/icons/Nuclias_Unity_QR.png";
import appStoreImg from "assets/images/icons/appstore.svg";
import googlePlayImg from "assets/images/icons/googleplay.svg";

import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import ModalContainer from "components/ModalContainer";
import { SolidButton } from "components/buttons/SolidButton";
import { getAppApiURL } from "utils/serverUrl";

const ModalProvisionApp = ({
  openModal,
  onCloseModal,
}) => {
  const theme = useTheme();
  const versionURL = `${getAppApiURL().replace(/\/$/, "")}/unauth/proxyConfig?t=${Date.now()}`;

  const [versionLoading, setVersionLoading] = useState(false);
  const [downloadLink, setDownloadLink] = useState(null);

  const handleCloseModal = () => {
    onCloseModal();
  }

  const handleCheckHereClick = () => {
    if (!downloadLink) return;
    window.open(downloadLink, '_blank', 'noopener,noreferrer');
  };

  const checkHereElement = (
    <Box
      component="span"
      onClick={handleCheckHereClick}
      sx={{
        ml: 0.5,
        color: theme.palette.primary.main,
        textDecoration: 'underline',
        cursor: downloadLink ? 'pointer' : 'default',
        opacity: downloadLink ? 1 : 0.5,
      }}>
      Click here
    </Box>
  );

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        setVersionLoading(true);
        const res = await fetch(versionURL);
        const data = await res.json();
        setDownloadLink(data?.platforms?.['windows-x86_64']?.url || null);
      } catch (err) {
        console.error("version fetch failed:", err);
      } finally {
        setVersionLoading(false);
      }
    };

    fetchVersion();
  }, []);

  return (
    <>
      <ModalContainer
        display={openModal}
        modalWidth="850px"
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              color: theme.palette.primary.main,
              fontFamily: theme.typography.fontFamily,
              fontSize: theme.typography.customFontSize[5],
              fontWeight: theme.typography.customFontWeight[3],
              paddingLeft: "20px",
            }}
          >
            Add Device
          </Typography>
          <Button
            onClick={handleCloseModal}
            sx={{
              backgroundColor: theme.palette.primary.transparent,
              boxShadow: "none",
              "&:hover": {
                backgroundColor: theme.palette.primary.transparent,
              },
            }}
          >
            <CloseIcon />
          </Button>
        </Box>
        <Box className={modalStyle['modal_Block']} style={{ margin: '30px 0' }}>
          <Typography
            sx={{
              color: theme.palette.primary.main,
              fontFamily: theme.typography.fontFamily,
              fontSize: theme.typography.customFontSize[5],
              fontWeight: theme.typography.customFontWeight[3],
              paddingLeft: "20px",
            }}
          >
            Download  Nuclias Unity Provision App
          </Typography>
        </Box>
        <Box className={modalStyle['modal_Block']} style={{ padding: '0 20px' }}>
          <Typography fontSize="16px" fontWeight="bold" color="rgba(0, 0, 0, 0.8)">
            Scan the QR code or click the button below to download the app.
          </Typography>
        </Box>
        <Box className={modalStyle['modal_Block']} style={{ padding: '0 20px' }}>
          <Typography fontSize="16px" fontWeight="bold" color="rgba(0, 0, 0, 0.8)">
            Easily add your devices to the cloud from your mobile.
          </Typography>
        </Box>
        <Box>
          <img
            src={qrCodeImg}
            alt="QR Code"
            style={{ display: 'block', margin: '50px auto', width: '120px' }}
          />
        </Box>
        <Box
          className={modalStyle['modal_Block']}
          style={{ gap: '40px', padding: '0 20px 30px 20px' }}
        >
          <img src={appStoreImg} alt="App Store" style={{ display: 'block', width: '204px' }} />
          <img src={googlePlayImg} alt="Google Play" style={{ display: 'block', width: '204px' }} />
        </Box>
        <Box style={{ marginTop: '10px', padding: '0 80px', textAlign: 'center', lineHeight: '28px' }}>
          For more advance users, setup a Unity Proxy in your local network would enable scan and provision remotely. {checkHereElement}.
        </Box>
        <Box className={modalStyle['modal_operation']} style={{ margin: '40px 0 20px 0' }}>
          <SolidButton
            className={modalStyle['modal_saveBtn']}
            style={{ width: '100px', height: '32px', fontSize: '16px' }}
            variant="contained"
            onClick={handleCloseModal}
          >
            OK
          </SolidButton>
        </Box>
      </ModalContainer>
    </>
  );
}

export default ModalProvisionApp;